import React,{ useContext, useState, useCallback } from "react"
import { Form, Message } from "semantic-ui-react"
import Panel from "../../../components/shared/Panel"
import { useTextResources } from "../../../language"
import ReservationContext from "../context"
import CustomerDropDown from '../../../components/shared/CustomerDropDown'
import PaymentArrangementsDropDown from '../../../components/shared/PaymentArrangementsDropDown'

export const CustomerPanel = ()=>{
    const text = useTextResources()
    const {reservation, setReservation} = useContext(ReservationContext)
    const [agent, setAgentItem] = useState(null)
    const [company, setCompanyItem] = useState(null)

    const AgentsSpec = React.useMemo(() => {
        return { CustomerTypeId: 2, GetOnlyCustomerArray: true, IsActive: true, IncludeCustomerProductCommission: true }
    }, [])
    const CompaniesSpec = React.useMemo(() => {
        return { CustomerTypeId: 1, GetOnlyCustomerArray: true, IsActive: true, IncludeCustomerProductCommission: true }
    }, [])

    const setAgent = val => {
        setReservation({ ...reservation, AgentId: val})
    }

    const setCompany = val => {
        setReservation({ ...reservation, CompanyId: val })
    }

    const setExternalMasterId = val => {
        setReservation({ ...reservation, ExternalReservationMasterId: val })
    }

    const commisionIncompatableCurrency = useCallback(() => {
        let result = false
        if (agent && agent.CustomerHotelProductCommissions && agent.CustomerHotelProductCommissions.length) {
            agent.CustomerHotelProductCommissions.forEach(commission => {
                result = result || (commission.FixedCommissionAmountBeforeTax && commission.FixedCommissionCurrencyId !== reservation.CurrencyId)
            })
        }
        if (company && company.CustomerHotelProductCommissions && company.CustomerHotelProductCommissions.length) {
            company.CustomerHotelProductCommissions.forEach(commission => {
                result = result || (commission.FixedCommissionAmountBeforeTax && commission.FixedCommissionCurrencyId !== reservation.CurrencyId)
            })
        }
        return result
    }, [agent, company, reservation])

    const missingMasterId = useCallback(() => {
        if (agent && agent.ExternalChannelId) {
            return !reservation.ExternalReservationMasterId
        } else {
            return false
        }
    }, [agent, reservation.ExternalReservationMasterId])

    return <Panel header={text("Customer")} icon="handshake outline">
    <Form>
        
            <Form.Field control={CustomerDropDown} clearable spec={AgentsSpec} label={text("Agent")}
                value={reservation.AgentId}
                onChange={setAgent}
                onChangeItem={setAgentItem}
                onValueNotFound={() => setAgent(null)} />
            <Form.Field control={CustomerDropDown} clearable spec={CompaniesSpec} label={text("Company")}
                value={reservation.CompanyId}
                onChange={setCompany}
                onChangeItem={setCompanyItem}
                onValueNotFound={() => setCompany(null)} />
        {commisionIncompatableCurrency() && <Message visible>
            {text("ProductCurrencyIsDifferentFromCustomerCommisison")}
        </Message>}
        {(agent && agent.ExternalChannelId) && <Form.Input required label={text("ExternalReservationMasterID")}
            defaultValue={reservation.ExternalReservationMasterId}
            onChange={(e, { value }) => setExternalMasterId(value)}
            error={missingMasterId() ? text("ExternalIDIsMandatory") : null}
        />}
        <Form.Field
                required
                value={reservation.PaymentArrangementId}
                control={PaymentArrangementsDropDown}
                label={text("PaymentArrangement")}></Form.Field>
    </Form>
</Panel>
}